<p-dialog 
  [(visible)]="visible" 
  [modal]="true" 
  (onHide)="onHide()" 
  [closable]="true"
  [appendTo]="'body'"
  header="Tutte le Notifiche"
  [style]="{ width: '90vw', maxWidth: '1000px' }"
  [maximizable]="true">
  
  <div class="w-full">
    <p-table 
      [value]="notifications" 
      [loading]="loading"
      [paginator]="true" 
      [rows]="rows"
      [first]="first"
      [totalRecords]="totalRecords"
      [lazy]="true"
      (onLazyLoad)="onPageChange($event)"
      [showCurrentPageReport]="true"
      currentPageReportTemplate="Mostrando {first} a {last} di {totalRecords} notifiche"
      [rowsPerPageOptions]="rowsPerPageOptions"
      size="small">
    
      <ng-template pTemplate="header">
        <tr>
          <th style="width: 10%">Stato</th>
          <th style="width: 60%">Descrizione</th>
          <th style="width: 30%">Data</th>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="body" let-notification>
        <tr [ngClass]="{'font-bold': !notification.notification_is_checked}">
          <td>
            <p-tag 
              [value]="notification.notification_is_checked ? 'Letta' : 'Non letta'" 
              [severity]="getSeverity(notification.notification_is_checked)">
            </p-tag>
          </td>
          <td>
            <div class="cursor-pointer" (click)="markAsRead(notification, $event)">
              {{ notification.notification_description }}
            </div>
          </td>
          <td>{{ getNotificationDate(notification.notification_created_at) | date:'short' }}</td>
        </tr>
      </ng-template>
      
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="3" class="text-center py-8">
            <div class="text-color-secondary">
              <i class="pi pi-bell text-4xl mb-2 block"></i>
              <p class="font-medium">Nessuna notifica trovata</p>
            </div>
          </td>
        </tr>
      </ng-template>
    </p-table>
  </div>

  <ng-template pTemplate="footer">
    <div class="flex justify-end">
      <button pButton type="button" label="Chiudi" (click)="onHide()"></button>
    </div>
  </ng-template>
</p-dialog>

